var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters, ViewChild, Utils, Components } from '@pacem/pacem-core';
import { EXPRESSION_METADATA_TYPE } from '../../../scaffolding/types';
import { EXPRESSION_WIDGET_METADATA_EXTRA, buildWidgetMetadata, gridifyMetadata } from '../../types';
import { PacemWidgetDataElement } from '../../helpers/data';
import { PacemWidgetFetchElement } from '../../helpers/fetcher';
import { DATACOLUMNS_METADATA_TYPE } from '../../scaffolding/datacolumns';
import { PacemUiWidgetElement } from '../types';
//namespace Pacem.Components.Cms {
const DATACOLUMN_METADATA = {
    display: { name: 'DataColumn' },
    props: [
        { prop: "header", type: "string", display: { name: "Header" } },
        { prop: "content", type: EXPRESSION_METADATA_TYPE, display: { name: "Content" }, extra: EXPRESSION_WIDGET_METADATA_EXTRA },
    ]
};
const DATAGRID_METADATA = buildWidgetMetadata({
    display: { icon: 'table_chart', name: 'DataGrid', description: 'DataGrid widget.' },
    props: [{
            prop: 'datasource', type: EXPRESSION_METADATA_TYPE, display: { name: 'Datasource' },
            extra: Utils.extend({}, EXPRESSION_WIDGET_METADATA_EXTRA, { filter: (e) => e instanceof PacemWidgetDataElement || e instanceof PacemWidgetFetchElement })
        },
        {
            prop: 'columns', type: DATACOLUMNS_METADATA_TYPE, display: { name: 'Columns' },
            // this will include 'datasource' as argument in the oneToMany source fn
            extra: { properties: 'datarowMetadata' },
            props: gridifyMetadata(DATACOLUMN_METADATA)
        }]
});
const DATAGRID_HEADING_SEPARATOR = 'pacem-widget-datagrid-heading';
function gridify(columns = []) {
    var output = '';
    for (let column of columns || []) {
        // if empty then 1fr
        const col = column.width || 1;
        if (typeof col === 'number') {
            output += col + 'fr ';
        }
        else {
            output += 'auto ';
        }
    }
    return output;
}
function datagridFragments(columns = []) {
    const fragHeading = document.createDocumentFragment(), fragBody = document.createDocumentFragment();
    let j = 1;
    for (let col of columns) {
        // heading
        const headcell = document.createElement('div');
        headcell.classList.add(PCSS + '-headcell');
        headcell.textContent = col.header;
        fragHeading.appendChild(headcell);
        // body
        const datacell = new Components.PacemSpanElement();
        datacell.classList.add(PCSS + '-datacell', 'datacell-corners');
        datacell.style.gridColumn = j.toString();
        datacell.setAttribute('css', "{{ {'grid-row': ^index+2} }}");
        datacell.setAttribute('content', col.content);
        fragBody.appendChild(datacell);
        j++;
    }
    const datarow = new Components.PacemPanelElement();
    datarow.classList.add(PCSS + '-datarow');
    datarow.setAttribute('css', "{{ {'grid-row': ^index+2} }}");
    datarow.setAttribute('css-class', "{{ {'datarow-alt': ^index % 2 === 1} }}");
    datarow.style.gridColumn = "1/" + (columns.length + 1);
    fragBody.appendChild(datarow);
    return { head: fragHeading, body: fragBody };
}
function datagridInnerHTML(id, columns = []) {
    const { head, body } = datagridFragments(columns);
    const head0 = document.createElement('div');
    head0.appendChild(head);
    const body0 = document.createElement('div');
    body0.appendChild(body);
    return `<${P}-repeater datasource="{{ #${id}.datasource }}">
    <div class="${PCSS}-datatable" style="grid-template-columns: ${gridify(columns)}">
    ${head0.innerHTML}
    <template>${body0.innerHTML}</template>
</div></${P}-repeater>`;
}
let PacemWidgetDataGridElement = class PacemWidgetDataGridElement extends PacemUiWidgetElement {
    constructor() {
        super(DATAGRID_METADATA);
        this.columns = [];
        this.datasource = [];
        this.datarowMetadata = [];
        this._builtUponDatasource = false;
    }
    _gridify(columns = this.columns) {
        var output = '';
        for (let column of columns || []) {
            // if empty then 1fr
            const col = column.width || 1;
            if (typeof col === 'number') {
                output += col + 'fr ';
            }
            else {
                output += 'auto ';
            }
        }
        return output;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'columns':
                    /*
                     *
                     * TODO: manage columns separately!
                     * Create an ad-hoc editor/formfield and a dedicated form
                     *
                     * */
                    this.innerHTML = datagridInnerHTML(this.id, val);
                    break;
                case 'datasource':
                    this._extractMetadataJustInCase(val);
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.innerHTML = datagridInnerHTML(this.id, this.columns);
    }
    _seekArray(ds) {
        if (Utils.isArray(ds)) {
            return ds;
        }
        if (typeof ds === 'object') {
            for (let prop in ds) {
                const arr = this._seekArray(ds[prop]);
                if (!Utils.isNull(arr)) {
                    return arr;
                }
            }
        }
        return null;
    }
    _extractMetadataJustInCase(ds = this.datasource) {
        if ((Utils.isNullOrEmpty(this.datarowMetadata) || this._builtUponDatasource) && !Utils.isNullOrEmpty(ds)) {
            const arr = this._seekArray(ds);
            if (!Utils.isNullOrEmpty(arr)) {
                const props = [];
                const item = arr[0];
                for (let prop in item) {
                    props.push({ prop, type: typeof item[prop] });
                }
                this.datarowMetadata = props;
                this._builtUponDatasource = true;
            }
        }
    }
};
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Json })
], PacemWidgetDataGridElement.prototype, "columns", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemWidgetDataGridElement.prototype, "datasource", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemWidgetDataGridElement.prototype, "datarowMetadata", void 0);
__decorate([
    ViewChild(`.${PCSS}-datatable`)
], PacemWidgetDataGridElement.prototype, "_datatable", void 0);
__decorate([
    ViewChild('template')
], PacemWidgetDataGridElement.prototype, "_template", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemWidgetDataGridElement.prototype, "_repeater", void 0);
PacemWidgetDataGridElement = __decorate([
    CustomElement({
        tagName: P + '-widget-datagrid'
    })
], PacemWidgetDataGridElement);
export { PacemWidgetDataGridElement };
